<ion-card-title [class]="cssClass()">
  <ng-content />
</ion-card-title>
